import { render } from "./MigracionTrazabilidad.vue?vue&type=template&id=7781b13d"
import script from "./MigracionTrazabilidad.vue?vue&type=script&lang=js"
export * from "./MigracionTrazabilidad.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__